export default __webpack_public_path__ + "static/media/twitch.9665ad35.svg";